import { ROUTES } from '@shared/utils';
import { allSports, discover, inPlay, myBets, offers } from '../../tabs/tabs';
import type { ProductNavigationConfig, SectionMatcher } from '../../types';

const { DISCOVERY, IN_PLAY, MY_BETS, ALL_SPORTS, OFFERS } = ROUTES.SPORTS;

const sportsNavigation: ProductNavigationConfig = {
  navigationTabs: [
    { ...discover, href: DISCOVERY },
    { ...inPlay, href: IN_PLAY },
    { ...myBets, href: MY_BETS },
    { ...offers, href: OFFERS },
    { ...allSports, href: ALL_SPORTS },
  ],
  sectionMatchers: [
    [`^/sportsbook\\?page=overview$`, 'discover'],
    ['^/sportsbook\\?page=live$', 'in_play'],
    ['^/sportsbook\\?page=betHistory$', 'my_bets'],
    ['^/sportsbook\\?page=allSports$', 'sports'],
    [`^${OFFERS}(/.*)?$`, 'offers'],
  ] satisfies SectionMatcher[],
  staticNavOnPages: [],
};

export { sportsNavigation };
